<template>
  <div class="container mx-auto px-4 bg-white h-screen">
    <div class="px-4 pt-20 pb-20">
      <Sidebar></Sidebar>
      <Header>{{$t('all.family')}}</Header>
      <p class="text-blue-dark">
        <b>{{$t('all.profile_data')}}</b>
      </p>
      <div
        v-if="message != ''"
        class=" py-1 text-pink text-sm"
      ><i>{{ message }}</i></div>
      <div class="flex">
        <div class="pt-4 flex-1">
          <p class="pb-2">
            <i class="text-xs">{{$t('all.common_name')}}</i><br>
            {{ individual.name }}
          </p>
        </div>
        <div class="pt-4 flex-1">
          <p class="pb-2">
            <i class="text-xs">{{$t('all.common_last_name')}}</i><br>
            {{ individual.surname }}
          </p>
        </div>
      </div>
      <div class="pt-4">
        <p class="pb-2">
          <i class="text-xs">{{$t('all.profile_fiscal_code')}}</i><br>
          {{ individual.fiscal_code }}
        </p>
      </div>
      <div class="pt-4">
        <p class="pb-2">
          <i class="text-xs">{{$t('all.profile_mobile')}}</i><br>
          {{ individual.mobile }}
        </p>
      </div>
      <div class="flex">
        <div class="pt-4 flex-1">
          <p class="pb-2 mr-1">
            <i class="text-xs">{{$t('all.family_relationship')}}</i><br>
            <input
              class="p-2 w-full border-b-2 border-grey"
              type="text"
              v-model="associate.relative"
              name="relative"
            >
          </p>
        </div>
      </div>
      <div
        v-if="message != ''"
        class="py-1 text-pink-dark text-sm border-2 p-2 mt-2 border-pink-dark">
        <i>{{ message }}</i>
      </div>
      <div
        class="rounded-full mt-5 p-4 py-2 bg-pink-dark text-white text-center cursor-pointer"
        @click="associateFamiliariToMinor({ id: id, individual: individual.id, associate: associate })"
      >{{$t('all.profile_associate')}}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['id'],
  data() {
    return {
      associate: {
        relative: '',
        is_admin: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      message: 'familiari/message',
      individual: 'familiari/individual',
    }),
  },
  methods: {
    ...mapActions('familiari', ['associateFamiliariToMinor']),
  },
};
</script>
